var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6.54545,
    fill: "#E5F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7273 25.0912L22.4572 26.8212C23.3093 27.6732 24.6907 27.6732 25.5428 26.8212L27.2727 25.0912M24 27.273V21.8185M34.9091 21.8185V29.4549C34.9091 31.8648 32.9554 33.8185 30.5455 33.8185H17.4545C15.0446 33.8185 13.0909 31.8648 13.0909 29.4549V18.5458C13.0909 16.1358 15.0446 14.1821 17.4545 14.1821H20.3636C21.3078 14.1821 22.2265 14.4884 22.9818 15.0549L25.0182 16.5821C25.7735 17.1486 26.6922 17.4549 27.6364 17.4549H30.5455C32.9554 17.4549 34.9091 19.4085 34.9091 21.8185Z",
    stroke: "#0085FF",
    strokeWidth: 1.63636,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download-2.a20f13b9d52f123398688dbecafbac6d.svg";
export { ForwardRef as ReactComponent };